<template>
  <div>
    <div class="mr-n2 mb-n2">
      <div v-for="item in pinLengths" :key="item" class="d-inline-block mr-2 mb-2 pin-checkbox">
        <input type="checkbox" :id="`${id}-${item}`" :value="item" v-model="model" class="pin-checkbox__check">
        <label :for="`${id}-${item}`" class="pin-checkbox__label">{{ item }}</label>
      </div>
    </div>
    <template v-if="!model.length">
      <div class="hint smaller text-danger mt-2">Please select at least one length</div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'PinLengthSelection',
  props: ['id', 'value'],
  data() {
    return {
      model: this.value || [],
    };
  },
  watch: {
    model(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.model = newVal;
    },
  },
  computed: {
    pinLengths() {
      return Array(14).fill(0).map((_, idx) => idx + 8);
    },
  },
};
</script>
